import supportedLocales from "@/configs/supported-locales"
export const getSupportedLocales = () => {
  let annotatedLocales = []
  for (const code of Object.keys(supportedLocales)) {
    annotatedLocales.push({
      code,
      name: supportedLocales[code]
    })
  }
  return annotatedLocales
}

export const supportedLocalesInclude = (locale) => Object.keys(supportedLocales).includes(locale)
